module.exports = __webpack_public_path__ + "img/cpfaheader.d617c062.png";